import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-8744">
      <PaymentForm data-id="element-8745" />
    </div>;
}